import { render, staticRenderFns } from "./SimpleCollapse.vue?vue&type=template&id=095c7d2e&scoped=true"
import script from "./SimpleCollapse.vue?vue&type=script&lang=js"
export * from "./SimpleCollapse.vue?vue&type=script&lang=js"
import style0 from "./SimpleCollapse.vue?vue&type=style&index=0&id=095c7d2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095c7d2e",
  null
  
)

export default component.exports